/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckCircleIcon16Regular = forwardRef('CheckCircleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.45 6.558a.75.75 0 1 0-1.06-1.06L7.153 8.734a.25.25 0 0 1-.354 0L5.522 7.458a.75.75 0 1 0-1.06 1.06l1.277 1.278a1.75 1.75 0 0 0 2.474 0l3.238-3.238Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
